import Vue from 'vue'
import App from './views/App'
import Login from './views/Login'
import router from './router'
import store from './store'
import api from './api'


import SubMenu from './components/common/sub-menu';
import LayoutContent from './components/LayoutContent'
import './style/app.less'
import 'font-awesome/css/font-awesome.css'
import moment from 'moment'
import './kernel/filters.js'

import BoxLayout from './components/BoxLayout'
Vue.component(LayoutContent.name, LayoutContent)
Vue.component('sub-menu', SubMenu);
Vue.component('BoxLayout', BoxLayout);

Vue.use(HeyUI)
Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.filter('format', (value, format = "YYYY-MM-DD") => {
    if (!value) return ''
    return moment(value).format(format)
})


const VueConfig = {
    router,
    store,
};

store.dispatch("init").then(() => {
    //实例化界面
    new Vue(Object.assign(VueConfig, {
        render: h => h(App)
    })).$mount('#app');
}).catch(() => {
    new Vue(Object.assign(VueConfig, {
        render: h => h(Login)
    })).$mount('#app');
});



